import { Loader } from '@ps/web-shared-ui';
import classNames from 'clsx';
import React from 'react';
import { useIntl } from 'react-intl';

import { TXTCLI_LoadingXX } from './LoadingIndicator.messages.json';
import styles from './LoadingIndicator.scss';
import PSLogo from './components/PSLogo';

interface Props {
  loading: boolean;
  className?: string;
  variant?: 'light' | 'dark' | 'poker';
}

const LoadingIndicator: React.FC<React.PropsWithChildren<Props>> = ({
  loading,
  children,
  variant = 'dark',
  className
}) => {
  const { formatMessage } = useIntl();

  if (!loading) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }

  if (variant === 'poker') {
    return <PSLogo />;
  }

  return (
    <div
      data-testid="loading-indicator"
      className={classNames(styles.centered, styles[variant], className)}
      role="status"
      aria-label={formatMessage(TXTCLI_LoadingXX)}
    >
      <Loader />
    </div>
  );
};

export default LoadingIndicator;
